<template>
	<div class="information">
		<XStateHeader />
		<XHeaderNav @on-search="goSearch" hide-back />
		<template v-if="role == 1">
			<div class="tab-wrapper">
				<div class="tab-box">
					<!--<div class="command">-->
					<!--	<div class="shadow-box"></div>-->
					<!--	<div class="text">推荐</div>-->
					<!--</div>-->
					<!--				<div class="tab-list">-->
					<!--					<div-->
					<!--						class="tab"-->
					<!--						:class="{ active: type === item.type }"-->
					<!--						v-for="item in tabList"-->
					<!--						@click="handleTabClick(item)"-->
					<!--					>-->
					<!--						{{ item.title }}-->
					<!--					</div>-->
					<!--				</div>-->
					<!--<div class="more">-->
					<!--	<img class="more-img" src="@/assets/images/information/tab.png" alt="" />-->
					<!--</div>-->
					<van-tabs v-model:active="type" @change="handleTabClick">
						<van-tab v-for="item in tabList" :title="item.title" :name="item.type" />
					</van-tabs>
				</div>
			</div>
			<div class="information-content">
				<DocumentList ref="documentList" v-show="type === 1" />
				<NoticeList ref="noticeList" v-show="type === 2" />
				<PublicityList re="publicityList" v-show="type === 3" />
			</div>
			<!--		<SubscribeList />-->
			<!--		<van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">-->
			<!--			<van-list-->
			<!--				v-model:loading="loading"-->
			<!--				:finished="finished"-->
			<!--				finished-text="没有更多了"-->
			<!--				@load="onLoad"-->
			<!--			>-->
			<!--				<div class="information-list">-->
			<!--					<div class="information-item" v-for="item in list" :key="item">-->
			<!--						<div class="content">-->
			<!--							新大办字 【2024】41号(关于印发《新疆大学推动高质量发展研讨会工作方案》…-->
			<!--						</div>-->
			<!--						<div class="date">2023-07-06</div>-->
			<!--					</div>-->
			<!--				</div>-->
			<!--			</van-list>-->
			<!--		</van-pull-refresh>-->
			<!--		<Notice />-->
		</template>
		<XEmpty v-else />
	</div>
</template>

<script setup lang="ts">
import XHeaderNav from '@/components/XHeaderNav.vue'
import XStateHeader from '@/components/XStateHeader.vue'
import { useRememberScroll } from '@/hooks/remeberScroll'
import { useAuthStore } from '@/store/auth'
import DocumentList from './components/DocumentList.vue'
import NoticeList from './components/NoticeList.vue'
import PublicityList from './components/PublicityList.vue'
import XEmpty from '@/components/XEmpty.vue'
import { onBeforeRouteLeave } from 'vue-router'

const route = useRoute()
const router = useRouter()

const documentList = ref(null)
const noticeList = ref(null)
const publicityList = ref(null)

const type = ref<number>(1)

const userStore = useAuthStore()
const role = computed(() => (['JZG'].includes(userStore.userInfo.F_QuickQuery) ? 1 : 2))

const tabList = [
	{
		type: 1,
		title: '公文'
	},
	{
		type: 2,
		title: '通知公告'
	},
	{
		type: 3,
		title: '宣传报道'
	}
]

const scrollTopMap = {
	1: 0,
	2: 0,
	3: 0
}

watch(type, (newVal, oldVal) => {
	console.log(document.documentElement.scrollTop, 'watch')
	scrollTopMap[oldVal] = document.documentElement.scrollTop
})

// useRememberScroll()

const handleTabClick = async () => {
	await nextTick()
	console.log(scrollTopMap[type.value], 'tabClick')
	document.documentElement.scrollTop = scrollTopMap[type.value]
	// document.documentElement.scrollTop = 0
}

onActivated(() => {
	if (route.params.refresh) {
		type.value = Number(route.query.type) || Number(route.params.type) || 1
		console.log(document.documentElement.scrollTop)
		document.documentElement.scrollTop = 0
		let ref =
			type.value === 1
				? documentList.value
				: type.value === 2
				? noticeList.value
				: publicityList.value
		ref.filters.start = 1
		ref.queryList()
		// filters.start = 1
		// queryList()
	} else {
		setTimeout(() => {
			document.documentElement.scrollTop = scrollTopMap[type.value]
		})
	}
})

onBeforeRouteLeave(() => {
	console.log('leave', document.documentElement.scrollTop)
	scrollTopMap[type.value] = document.documentElement.scrollTop
})

onMounted(() => {
	type.value = Number(route.query.type) || Number(route.params.type) || 1
	// queryList()
	// getXcList()
})

const goSearch = () => {
	router.push({
		path: '/layout/information-search'
	})
}
</script>

<style scoped lang="scss">
.information {
	background-color: #fff;
	padding-bottom: 60px;
	&::-webkit-scrollbar {
		display: none;
	}
	.tab-wrapper {
		height: 40px;
	}
	.tab-box {
		position: fixed;
		width: 100vw;
		font-size: 14px;
		border-bottom: 2px solid #f4f3f3;
		background-color: #fff;
		margin-bottom: 15px;
		z-index: 3;
		.command {
			background-color: transparent;
			position: relative;
			.shadow-box {
				position: absolute;
				width: 58px;
				height: 18px;
				left: 0;
				top: 50%;
				transform: translateY(-50%);
				box-shadow: 2px 0 4px 0 rgba(0, 0, 0, 0.15);
				z-index: 0;
			}
			.text {
				z-index: 1;
				position: relative;
				width: 58px;
				padding: 10px 0 8px;
				text-align: center;
				background-color: #fff;
				line-height: 16px;
			}
		}
		.tab-list {
			overflow: scroll;
			display: flex;
			padding-right: 20px;
			&::-webkit-scrollbar {
				display: none;
			}
			.tab {
				flex: 1 0 auto;
				min-width: 0;
				padding: 10px 15px 8px;
				line-height: 16px;
			}
		}
		.active {
			color: $primaryColor;
			font-weight: 500;
			position: relative;
			&:after {
				content: '';
				position: absolute;
				bottom: 0;
				left: 50%;
				transform: translateX(-50%);
				width: 20px;
				height: 2px;
				background: #bd3a36;
				border-radius: 17px;
			}
		}
		.more {
			width: 32px;
			height: 100%;
			position: absolute;
			top: 0;
			right: 0;
			background: linear-gradient(270deg, #ffffff 87%, rgba(255, 255, 255, 0) 100%);
			padding-top: 10px;
			padding-left: 5px;
			.more-img {
				width: 16px;
			}
		}
	}
	.information-content {
		padding-top: 10px;
	}
}
</style>
